export default {"src":"/_next/static/media/LiverDisease.08c214a7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};